/**
 * 资源管理相关
 */
import axios from "../../utils/axios";

// 用户列表
export function users(data) {
    return axios({
        url: "/admin/user/manager/users",
        method: "POST",
        data: data
    });
}

// 给用户备注
export function remark(data) {
    return axios({
        url: "/admin/user/manager/remark",
        method: "POST",
        data: data
    });
}

// 用户数据统计
export function statistics(query) {
    return axios({
        url: "/admin/user/index/statistics",
        method: "get",
        params: query
    });
}

// 设置信用额
export function credit_limit(data) {
    return axios({
        url: "/admin/user/manager/credit_limit",
        method: "post",
        data: data
    });
}

// 设置用户属性
export function set_property_admin(data) {
    return axios({
        url: "/admin/user/manager/set_property_admin",
        method: "post",
        data: data
    });
}
